{
  "unauthorized": {
    "errorCode": "403",
    "title": "Pääsy estetty",
    "subtitle": "Sinulla ei ole oikeutta käyttää tätä sivua.",
    "backToChat": "Siirry keskusteluun",
    "helpText": "Jos uskot tämän olevan virhe, ota yhteyttä organisaatiosi ylläpitäjään."
  },
  "missionChat": {
    "agentNotRespondingDescription": "Isäntä \"{{hostName}}\" on yhteydessä, mutta agentin ajoympäristö ei vastaa. Varmista, että agenttisovellus on käynnissä isännällä.",
    "hostOfflineDescription": "Agentti-isäntä \"{{hostName}}\" ei ole nyt yhteydessä.",
    "accessDenied": "Ei käyttöoikeutta",
    "accessDeniedDescription": "Sinulla ei ole oikeutta avata tätä missiota.",
    "agentNotResponding": "Agentti ei vastaa",
    "agentNotRespondingHint": "Tarkista, että agion-sdk-agentti on käynnissä ja kuuntelee porttia 8190.",
    "connectionError": "Yhteysvirhe",
    "connectionErrorDescription": "Yhteyttä missioon ei saatu.",
    "error": "Jokin meni pieleen",
    "hostNotFound": "Isäntä ei ole käytettävissä",
    "hostNotFoundDescription": "Tämän mission agentti-isäntää ei löytynyt.",
    "hostOffline": "Isäntä ei ole yhteydessä",
    "hostOfflineHint": "Varmista, että agentti-isäntä on käynnissä ja yhteydessä VPN:ään.",
    "loadingHost": "Yhdistetään isäntään...",
    "notFoundDescription": "Tätä missiota ei ole, tai se on ehkä poistettu.",
    "retry": "Yritä uudelleen",
    "retryConnection": "Yhdistä uudelleen",
    "launching": "Käynnistetään...",
    "runMission": "Suorita missio",
    "loading": "Ladataan mission keskustelua...",
    "notFound": "Missiota ei löytynyt",
    "loadError": "Mission lataaminen epäonnistui"
  },
  "files": {
    "title": "Tiedostot",
    "subtitle": "Hallitse ladattuja tiedostoja ja dataa",
    "searchPlaceholder": "Hae tiedostoja...",
    "count_one": "{{count}} tiedosto",
    "count_other": "{{count}} tiedostoa",
    "loading": "Ladataan tiedostoja...",
    "noFilesFound": "Tiedostoja ei löytynyt",
    "noFilesUploaded": "Ei ladattuja tiedostoja",
    "adjustSearch": "Kokeile muuttaa hakutermiä",
    "uploadFirst": "Lataa ensimmäinen tiedostosi aloittaaksesi",
    "deleteConfirm": "Haluatko varmasti poistaa tämän tiedoston?",
    "deleteSuccess": "Tiedosto poistettu onnistuneesti",
    "fileRemoved": "Tiedosto poistettu",
    "deleteError": "Tiedoston poistaminen epäonnistui",
    "downloadError": "Tiedoston lataaminen epäonnistui",
    "downloadSuccess": "Tiedosto ladattu onnistuneesti",
    "clickToRename": "Klikkaa nimetäksesi tiedoston uudelleen",
    "referenceHint": "Valmis-tilassa oleviin tiedostoihin voi viitata keskustelussa",
    "columnName": "Nimi",
    "columnSize": "Koko",
    "columnDate": "Ladattu",
    "columnStatus": "Tila",
    "time": {
      "justNow": "Juuri nyt",
      "minutesAgo": "{{count}} min sitten",
      "hoursAgo": "{{count}} h sitten",
      "daysAgo": "{{count}} pv sitten"
    }
  },
  "agents": {
    "title": "Agentit",
    "subtitle": "Valitse agentti aloittaaksesi keskustelun",
    "searchPlaceholder": "Hae agentteja nimellä, mallilla tai ominaisuudella...",
    "count_one": "{{count}} agentti saatavilla",
    "count_other": "{{count}} agenttia saatavilla",
    "loading": "Ladataan agentteja...",
    "error": "Agenttien lataaminen epäonnistui",
    "noAgentsFound": "Agentteja ei löytynyt",
    "noAgentsAvailable": "Ei agentteja saatavilla",
    "adjustSearch": "Kokeile muuttaa hakutermiä",
    "noAgentsConfigured": "Tekoälyagentteja ei ole tällä hetkellä määritetty",
    "clickToChat": "Klikkaa mitä tahansa agenttia aloittaaksesi keskustelun..."
  },
  "profile": {
    "title": "Profiili",
    "subtitle": "Hallitse tilisi asetuksia ja mieltymyksiä",
    "loading": "Ladataan profiilia...",
    "updateSuccess": "Profiili päivitetty onnistuneesti!",
    "firstName": "Etunimi",
    "firstNamePlaceholder": "Syötä etunimi",
    "lastName": "Sukunimi",
    "lastNamePlaceholder": "Syötä sukunimi",
    "email": "Sähköposti",
    "emailReadonly": "Sähköpostia ei voi muuttaa",
    "emailCannotChange": "Sähköpostia ei voi muuttaa. Ota yhteyttä tukeen, jos sinun täytyy päivittää se.",
    "connectedVia": "Yhdistetty palvelun {{provider}} kautta",
    "notSet": "Ei asetettu",
    "changePassword": "Vaihda salasana",
    "currentPassword": "Nykyinen salasana",
    "currentPasswordPlaceholder": "Syötä nykyinen salasana",
    "newPassword": "Uusi salasana",
    "newPasswordPlaceholder": "Syötä uusi salasana",
    "newPasswordHint": "Vähintään 8 merkkiä, sisältäen isoja ja pieniä kirjaimia, numeron ja erikoismerkin",
    "confirmPassword": "Vahvista uusi salasana",
    "confirmPasswordPlaceholder": "Vahvista uusi salasana",
    "changingPassword": "Vaihdetaan salasanaa...",
    "passwordSuccess": "Salasana vaihdettu onnistuneesti!",
    "passwordMismatch": "Uudet salasanat eivät täsmää",
    "passwordError": "Salasanan vaihtaminen epäonnistui",
    "edit": "Muokkaa",
    "saveError": "Muutosten tallentaminen epäonnistui. Yritä uudelleen.",
    "defaultOrganization": "Agion Platform",
    "validation": {
      "minLength": "Salasanan tulee olla vähintään 8 merkkiä pitkä",
      "complexity": "Salasanan tulee sisältää vähintään yksi numero tai erikoismerkki"
    },
    "providers": {
      "google": "Google",
      "microsoft": "Microsoft",
      "email": "Sähköposti ja salasana",
      "agion": "Agion"
    }
  },
  "nextPages": {
    "aboutSection": "Tietoa: {{subject}}",
    "files": {
      "actions": "Toiminnot",
      "deleteTitle": "Poistetaanko {{name}}?",
      "loadError": "Tiedostojasi ei voitu ladata",
      "loadErrorBody": "Tiedostojasi ei voitu lukea. Yritä hetken kuluttua uudelleen.",
      "emptyTitle": "Ei vielä tiedostoja",
      "emptyBody": "Mission ajoon liittämäsi tiedostot näkyvät täällä.",
      "moreActionsFor": "Lisää toimintoja: {{name}}"
    },
    "profile": {
      "youTitle": "Sinä",
      "youInfo": "Nimesi, sähköpostiosoitteesi ja roolisi tässä organisaatiossa.",
      "role": "Rooli",
      "preferencesTitle": "Asetukset",
      "preferencesInfo": "Kieli, jota chat käyttää sinulle.",
      "language": "Kieli",
      "languageHint": "Tallennetaan tilillesi, joten kielesi seuraa sinua selaimesta toiseen.",
      "languageSaveFailed": "Kieltäsi ei voitu tallentaa.",
      "passwordInfo": "Vaihda salasana, jolla kirjaudut sisään. Tarvitset nykyisen salasanasi.",
      "showPassword": "Näytä salasana",
      "hidePassword": "Piilota salasana",
      "loadError": "Profiiliasi ei voitu ladata",
      "loadErrorBody": "Tilisi tietoja ei voitu lukea. Yritä hetken kuluttua uudelleen.",
      "openedBy": {
        "title": "Kuka avasi keskustelujasi",
        "info": "Henkilöt, jotka avasivat tai veivät ulos aloittamasi keskustelun sisällön, uusin ensin.",
        "loading": "Ladataan, kuka avasi keskustelujasi…",
        "loadError": "Tietoa siitä, kuka avasi keskustelujasi, ei voitu ladata",
        "empty": "Kukaan muu ei ole avannut keskustelujasi.",
        "showMore": "Näytä lisää",
        "who": "{{name}} ({{role}})",
        "formerMember": "Entinen jäsen",
        "unnamedMember": "Organisaatiosi jäsen",
        "read": "{{who}} avasi keskustelusi {{mission}} {{date}}",
        "export": "{{who}} vei ulos keskustelusi {{mission}} {{date}}"
      }
    }
  }
}
